export const POINTS_WATCHING = "Points Watching"

// tooltip names
export const BACK = "Back"

// modes (spec §4.1)
export const MODE = {
    SESSION: 'session',
    EMPLOYEE: 'employee',
}

export const ALL_FILTER = 'ALL'

// Visual design tokens (spec §8)
export const C = {
    navy: '#0f1640',
    navy2: '#101935',
    peri: '#8e9bf0',
    periInk: '#9fb0ff',
    track: '#eef1fb',
    ink: '#3a4a9a',
    yellow: '#f5d800',
    gold: '#f5c400',
    iconBlue: '#6f86ff',
    focus: '#2b3a8f',
    alertRed: '#ef4444',
    amberBg: '#fef3c7',
    amberIcon: '#b45309',
}


export const POINTS_WATCHING_CUSTOMER_FIELDS = [
    {},
    {id: 'pointPicture', label: 'Points Picture', align: "center"},
    {id: 'idPicture', label: 'ID Picture', align: "center"},
    {id: 'customer', label: 'Customer', align: "center"},
    {id: 'points', label: 'Points ', align: "center"},
    {id: 'signInDate', label: 'Date Time Given', align: "center"},
    {id: 'ticket', label: 'Machine', align: "center"},
    {id: 'type', label: 'Given By', align: "center"},
]
